module.exports = __webpack_public_path__ + "static/media/barnard.416c8cfa.jpg";